/** Console debug wrapper */
const debug = (...args: any[]) => {
  if (process.env.NEXT_PUBLIC_CHAT_DEBUG_MODE) {
    console.debug("[Chat SDK]:", ...args);
  }
};

export default debug;
